import * as React from "react";
const SvgAsana = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("g", { clipPath: "url(#Asana_svg__a)" },
        React.createElement("rect", { width: 24, height: 24, fill: "#F7F7F7", rx: 6 }),
        React.createElement("circle", { cx: 12, cy: 7.5, r: 4, fill: "#F06A6A" }),
        React.createElement("circle", { cx: 17, cy: 16.5, r: 4, fill: "#F06A6A" }),
        React.createElement("circle", { cx: 7, cy: 16.5, r: 4, fill: "#F06A6A" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "Asana_svg__a" },
            React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })))));
export default SvgAsana;
//# sourceMappingURL=Asana.js.map